import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import BridgeYourCreativeVision from "./sections/BridgeYourCreativeVision";
import TheGrowthLadder from "./sections/TheGrowthLadder";
import PrecisionInNumbers from "./sections/PrecisionInNumbers";
import WhyConnectors from "./sections/WhyConnectors";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import TheInnerCircle from "./sections/TheInnerCircle";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <BridgeYourCreativeVision />
      <TheGrowthLadder />
      <PrecisionInNumbers />
      <WhyConnectors />
      <ClientSuccessStories />
      <TheInnerCircle />
      <Footer />
    </div>;
}